import { render, staticRenderFns } from "./MessageDetails.vue?vue&type=template&id=0a1a0df5&scoped=true&"
import script from "./messageDetails.js?vue&type=script&lang=js&"
export * from "./messageDetails.js?vue&type=script&lang=js&"
import style0 from "./MessageDetails.vue?vue&type=style&index=0&id=0a1a0df5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a0df5",
  null
  
)

export default component.exports